import { io } from "socket.io-client";

/**
 * Client for the AI assistant backend (langchainAlt).
 * All communication is over Socket.IO (websocket transport only).
 */

export function resolveAIBaseUrl() {
  if (process.env.REACT_APP_AI_API_URL) {
    return process.env.REACT_APP_AI_API_URL.replace(/\/+$/, "");
  }

  // Legacy env pointed at the full chat endpoint; derive the base from it.
  if (process.env.REACT_APP_LANGCHAIN_API_URL) {
    return process.env.REACT_APP_LANGCHAIN_API_URL.replace(/\/api\/chat\/?$/, "").replace(/\/+$/, "");
  }

  return "http://localhost:3003";
}

export function getAuthToken() {
  return window.localStorage.getItem("tokenV2") || window.localStorage.getItem("token") || "";
}

export function createAISocket({ patientId }) {
  const token = getAuthToken();

  const sockUrl = resolveAIBaseUrl();

  // TEMP
  console.log("SOCK URL ===>>>", sockUrl)

  return io(sockUrl, {
    transports: ["websocket"],
    reconnection: true,
    reconnectionAttempts: Infinity,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 10000,
    timeout: 10000,
    auth: {
      token,
      patientId: patientId ? String(patientId) : undefined,
      role: "patient",
    },
  });
}

const SOCKET_ACK_TIMEOUT_MS = 90000;

export function emitWithAck(socket, event, payload) {
  return new Promise((resolve, reject) => {
    const timer = setTimeout(() => {
      reject(new Error("The assistant took too long to respond. Please try again."));
    }, SOCKET_ACK_TIMEOUT_MS);

    socket.emit(event, payload, (response) => {
      clearTimeout(timer);

      if (response && response.ok === false) {
        reject(new Error(response.error || "Request failed"));
        return;
      }

      resolve(response || {});
    });
  });
}

// Resolves once the socket is connected; socket.io keeps retrying in the
// background, so this just waits for the next successful (re)connection.
export function waitForConnection(socket, timeoutMs = 8000) {
  if (socket.connected) {
    return Promise.resolve();
  }

  return new Promise((resolve, reject) => {
    const timer = setTimeout(() => {
      socket.off("connect", onConnect);
      reject(new Error("Could not reach the assistant. Please check your connection."));
    }, timeoutMs);

    const onConnect = () => {
      clearTimeout(timer);
      resolve();
    };

    socket.once("connect", onConnect);
  });
}

export function conversationStorageKey(patientId) {
  return `aiChat:conversationId:${patientId}`;
}

export function loadStoredConversationId(patientId) {
  if (!patientId) return null;
  return window.localStorage.getItem(conversationStorageKey(patientId));
}

export function storeConversationId(patientId, conversationId) {
  if (!patientId) return;

  if (conversationId) {
    window.localStorage.setItem(conversationStorageKey(patientId), conversationId);
  } else {
    window.localStorage.removeItem(conversationStorageKey(patientId));
  }
}
